export default __webpack_public_path__ + "static/media/store-listing.5b39274b.svg";